import ReactDOM from 'react-dom/client'
import { pipe } from 'remeda'
import { SearchResults } from '@components/SearchResults/SearchResults'
import { withAlgoliaSearch, withExchangeRates, withSkeletonTheme } from '@hocs'
import { withApollo } from '../hocs/withApollo'
import { withCategoriesGrid } from '../hocs/withCategoriesGrid'
import { withErrorBoundary } from '../hocs/withErrorBoundary'
import { withI18next } from '../hocs/withI18next'
import { withSuspense } from '../hocs/withSuspense'
import { withTheme } from '../hocs/withTheme'
import { withWishlist } from '../hocs/withWishlist'

export const renderSearch = (searchEl: HTMLElement | null) => {
  if (!searchEl) {
    return
  }

  const SearchWrapper = pipe(
    SearchResults,
    withExchangeRates,
    withWishlist,
    withAlgoliaSearch,
    withSuspense,
    withApollo,
    withCategoriesGrid,
    withErrorBoundary,
    withSkeletonTheme,
    withI18next,
    withTheme,
  )

  ReactDOM.createRoot(searchEl).render(<SearchWrapper />)
}
